'use client'

import { cn } from '@/utilities/ui'
import React, { useEffect, useRef, useState } from 'react'

import { type MediaProps } from '.'

import { ImageWithFallback } from './ImageWithFallback'
import { placeholderImageUri } from '@/utilities/placeholder'

function normalizeUrl(url: string) {
    if (url.startsWith('/')) {
        return url.slice(1)
    }

    return url
}

export const VideoWithFallback: React.FC<MediaProps> = ({ media, options = {} }) => {
    const videoRef = useRef<HTMLVideoElement>(null)
    const [showFallback, setShowFallback] = useState<boolean>()

    const width = options?.width ?? 300
    const height = options?.height ?? 150

    useEffect(() => {
        const { current: video } = videoRef
        if (video) {
            video.addEventListener('suspend', () => {
                // Browser has blocked playback
                setShowFallback(true)
            })

            video.addEventListener('error', () => {
                // Error playing/finding video
                setShowFallback(true)
            })
        }
    }, [])

    if (media && typeof media === 'object') {
        if (showFallback || !media.url) {
            return <ImageWithFallback src={media.thumbnailURL || placeholderImageUri} alt='placeholder' width={width} height={height} />
        }

        const cloudflareVideoOptions = ['mode=video', `width=${width}`, `height=${height}`, 'fit=contain']

        return (
            <video
                className={cn(options?.className)}
                loop
                muted
                controls
                autoPlay={options.autoPlay}
                controlsList='nofullscreen nodownload noremoteplayback noplaybackrate'
                playsInline
                ref={videoRef}
                width={width}
                height={height}
            >
                <source src={`https://not-qz.com/cdn-cgi/media/${cloudflareVideoOptions.join(',')}/${normalizeUrl(media.url)}`} type='video/mp4' />
            </video>
        )
    }

    return null
}
